export default "__VITE_ASSET__CMiPJDKW__"